import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const userServiceApi = createApi({
    reducerPath: 'userServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['User'],
    endpoints: (builder) => ({

        getUser: builder.query({
            query: () => `/v1/users`,
            providesTags: ['User'],
        }),
        

        createUser: builder.mutation({
            query: (formData) => ({
                url: `/v1/users/add`,
                method: 'POST',
                body: formData,
                headers: {
                    'authorization': token,
                },
            }),
            invalidatesTags: ['User'],
        }),

        updateUser: builder.mutation({
             query: (data) =>({
                url: `/v1/users/users/${data.id}`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                },
                body: data.values,
            }),
            invalidatesTags: ['User'],
        }),

       
    }),
});

export const {  useCreateUserMutation, useGetUserQuery, useUpdateUserMutation} = userServiceApi;